import { Flex, Grid, Text } from '@chakra-ui/react'

import MonthCalendar from './MonthCalendar'
import NextEvents from './NextEvents'

import Layout from 'components/ManagerLayout'
import Card from 'components/Card/Card'
import CardBody from 'components/Card/CardBody'
import CardHeader from 'components/Card/CardHeader'

const Calendar = () => {
    return (
        <Layout>
            <Grid
                w="full"
                templateColumns="repeat(1, 3fr 1fr)"
                templateRows="repeat(1, 1fr)"
                gap="16px"
                mb="16px"
            >
                <Card
                    overflowX={{ sm: "auto", lg: "unset" }}
                    px="22px"
                >
                    <CardBody w="full" h="full">
                        <MonthCalendar />
                    </CardBody>
                </Card>
                <Card
                    minHeight="100px"
                    overflowX={{ sm: "auto", lg: "unset" }}
                >
                    <CardHeader>
                        <Flex w="full" justifyContent="space-between" alignItems="center">
                            <Text>Próximos eventos</Text>
                        </Flex>
                    </CardHeader>
                    <CardBody w="full" h="full">
                        <NextEvents />
                    </CardBody>
                </Card>
            </Grid>
        </Layout>
    )
}

export default Calendar